module.exports = __webpack_public_path__ + "img/cert26.8f36242c.png";